var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBarcode(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_819_1853)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.4917 16.0654C0.76318 16.0654 0.9834 15.8455 0.9834 15.5737V0.4917C0.9834 0.21997 0.76319 0 0.4917 0C0.22022 0 0 0.21997 0 0.4917V15.5737C0 15.8455 0.22021 16.0654 0.4917 16.0654Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.11365 16.0654C3.38513 16.0654 3.60535 15.8455 3.60535 15.5737V0.4917C3.60535 0.21997 3.38514 0 3.11365 0C2.84217 0 2.62195 0.21997 2.62195 0.4917V15.5737C2.62195 15.8455 2.84216 16.0654 3.11365 16.0654Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8846 16.0654C17.1561 16.0654 17.3763 15.8455 17.3763 15.5737V0.4917C17.3763 0.21997 17.1561 0 16.8846 0C16.6132 0 16.3929 0.21997 16.3929 0.4917V15.5737C16.3929 15.8455 16.6132 16.0654 16.8846 16.0654Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5077 0C19.2362 0 19.016 0.21997 19.016 0.4917V15.5737C19.016 15.8455 19.2362 16.0654 19.5077 16.0654C19.7792 16.0654 19.9994 15.8455 19.9994 15.5737V0.4917C19.9994 0.21997 19.7792 0 19.5077 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3278 16.0654C10.5992 16.0654 10.8195 15.8455 10.8195 15.5737V0.4917C10.8195 0.21997 10.5992 0 10.3278 0C10.0563 0 9.83606 0.21997 9.83606 0.4917V15.5737C9.83606 15.8455 10.0563 16.0654 10.3278 16.0654Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.99963,
    y: 0.0000610352,
    width: 2,
    height: 16,
    rx: 1,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.9996,
    y: 0.0000610352,
    width: 3,
    height: 16,
    rx: 1,
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_819_1853"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9994,
    height: 16.0654,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarcode);
export default __webpack_public_path__ + "static/media/Barcode.b9f72ff1f34e410416bd8e7be4498535.svg";
export { ForwardRef as ReactComponent };